var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCerrar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1418_119168",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1418_119168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.53125 8.65625L4.54688 11.6406C4.38021 11.8073 4.18229 11.8906 3.95312 11.8906C3.72396 11.8906 3.52604 11.8073 3.35938 11.6406C3.19271 11.474 3.10938 11.2788 3.10938 11.055C3.10938 10.8308 3.19271 10.6354 3.35938 10.4688L6.35938 7.46875L3.34375 4.46875C3.17708 4.30208 3.09375 4.10937 3.09375 3.89062C3.09375 3.67187 3.17708 3.47917 3.34375 3.3125C3.51042 3.14583 3.70563 3.0625 3.92938 3.0625C4.15354 3.0625 4.34896 3.14583 4.51562 3.3125L7.5 6.28125L10.4531 3.32812C10.6198 3.16146 10.8177 3.07813 11.0469 3.07813C11.276 3.07813 11.474 3.16146 11.6406 3.32812C11.8073 3.49479 11.8906 3.69521 11.8906 3.92938C11.8906 4.16396 11.8073 4.36458 11.6406 4.53125L8.67188 7.51562L11.6562 10.5C11.8125 10.6562 11.8906 10.849 11.8906 11.0781C11.8906 11.3073 11.8125 11.5 11.6562 11.6562C11.5 11.8125 11.31 11.8906 11.0863 11.8906C10.8621 11.8906 10.6719 11.8125 10.5156 11.6562L7.53125 8.65625Z",
    fill: "#AEB0B0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerrar);
export default __webpack_public_path__ + "static/media/Cerrar.c18b2919322766888f49aa9f2b6ce8f9.svg";
export { ForwardRef as ReactComponent };